import AppDispatcher from '../dispatcher/AppDispatcher';
import SiteHeaderConstants from '../constants/SiteHeaderConstants';

class SiteHeaderActionCreator {
  setCurrentMenu(item) {
    AppDispatcher.handleViewAction({
      actionType: SiteHeaderConstants.SET_CURRENT_MENU,
      data: item,
    });
  }

  setModalConfig(config) {
    AppDispatcher.handleViewAction({
      actionType: SiteHeaderConstants.SET_MODAL_CONFIG,
      data: config,
    });
  }

  setLoadingFlag(bool) {
    AppDispatcher.handleViewAction({
      actionType: SiteHeaderConstants.SET_LOADING_FLAG,
      data: bool,
    });
  }

  setDisableHeaderFlag(bool) {
    AppDispatcher.handleViewAction({
      actionType: SiteHeaderConstants.SET_DISABLE_HEADER_FLAG,
      data: bool,
    });
  }

  toBeSelectedNavItem(navData) {
    AppDispatcher.handleViewAction({
      actionType: SiteHeaderConstants.SET_TO_BE_SELECTED_NAV,
      data: navData,
    });
  }

  setSideBarFlag(bool) {
    AppDispatcher.handleViewAction({
      actionType: SiteHeaderConstants.SET_SIDEBAR_FLAG,
      data: bool,
    });
  }

  hideHeaderFlag(bool) {
    AppDispatcher.handleViewAction({
      actionType: SiteHeaderConstants.HIDE_HEADER_FLAG,
      data: bool,
    });
  }

  setManageCredFlag(bool) {
    AppDispatcher.handleViewAction({
      actionType: SiteHeaderConstants.MANAGE_CREDENTIALS_FLAG,
      data: bool,
    });
  }
}

export default new SiteHeaderActionCreator();
